import type { RegisterAPI } from './register-api.types';

import http from './register-api.http';

export default {
  associates: {
    delete: async (companyId: number, data: RegisterAPI.DeleteAssociateRequest) => {
      await http.delete(`/v2/company/${companyId}/associates`, { data });
    },

    update: async (companyId: number, data: RegisterAPI.UpdateAssociateRequest) => {
      const res = await http.put<RegisterAPI.UpdateAssociateResponse>(
        `/v2/company/${companyId}/associates`,
        data,
      );
      return res.data.data;
    },
  },

  company: {
    startEscrowAccount: async (companyId: number) => {
      await http.post(`/v2/company/${companyId}/escrow-account/start`);
    },

    update: async (companyId: number, data: RegisterAPI.UpdateCompanyRequest) => {
      await http.put(`/v2/company/${companyId}`, data);
    },
  },

  partner: {
    getDetails: async (partnerId: number): Promise<RegisterAPI.GetPartnerDetailResponse> => {
      const res = await http.get<RegisterAPI.GetPartnerDetailResponse>(
        `/v2/partner/${partnerId}`,
        { params: { must_have_user_id: false, with_documents: true } },
      );
      return res.data;
    },
  },
};
